import Entity from "../templates/entity.js";
import sortTerms from "../helpers/sortObjects.js";
import setChiclet from "../helpers/chiclet.js";
import modalSearch from "../helpers/modalSearch.js";

const programsModalWidget = instantsearch.connectors.connectRefinementList(
	(
		{ widgetParams, canRefine, items, createURL, refine, helper,
		searchForItems, isFromSearch },
		isFirstRender
	) => {
		if ( ! brookingsAlgoliaFeedOptions.facets.includes('programs') ) {
			return;
		}

		const container = document.getElementById('programs-filter-modal');

		if (isFirstRender) {
			document.querySelector('#programFacets').classList.add('active');

			container.addEventListener("click", ({ target }) => {
				const input = target.closest(
					'input[type="checkbox"]'
				);

				if (input) {
					refine(input.value);
				}
			});

			return;
		}

		modalSearch(container);

		if (!isFromSearch) {
			// container.querySelector('#liveSearchResearchProgram').value = "";
		}

		const tmTerms = JSON.parse(brookingsAlgolia.entities);
		const allTerms = sortTerms( items, tmTerms );

		container.querySelector("#researchProgramFiltersContainer").innerHTML =
			allTerms.map(
				({
					value,
					id,
					isRefined,
					label,
					highlighted,
					count,
					children,
				}) => Entity({
					value,
					id,
					isRefined,
					label,
					highlighted,
					count,
					children,
					'type' : 'entity'
				})
			)
			.join("");

		if ( ! isFirstRender ) {
			// clear .search-field
			const searchField = document.querySelector(`#programs-filter-modal .search-field`);
			// on .form-checkbox click, clear searchField value
			const formCheckboxes = document.querySelectorAll(`#programs-filter-modal .form-checkbox`);
			formCheckboxes.forEach((formCheckbox) => {
				formCheckbox.addEventListener('click', () => {
					searchField.value = '';
				});
			});
			// Expand toggles if any sub-filter is checked
			const subFilters = container.querySelectorAll('.sub-filters');
			subFilters.forEach((subFilter) => {
				const inputs = subFilter.querySelectorAll('input[type="checkbox"]');
				if (inputs.length > 0) {
					inputs.forEach((input) => {
						if (input.checked || searchField.value !== '') {
							const parentItem = input.closest('.item-parent');
							if ( parentItem ) {
								const toggle = parentItem.querySelector('.sub-filters');
								if ( toggle ) {
									toggle.removeAttribute('hidden');
								}
							}
						}
					});
				}
			});

			if ( items.length > 0 ) {
				items.forEach( (item) => {
					var term = tmTerms.find( (term) => term.term_id == item.value );
					if ( ! term ) {
						for ( let child of tmTerms ) {
							if ( child.children ) {
								var term = child.children.find( (term) => term.term_id == item.value );
								if ( term ) {
									break;
								}
							}
						}
					}
					if ( term ) {
						item.label = term.title;
					}
					setChiclet(item,widgetParams.attribute,refine, term);
				});
			}
		}
	}
);

export default programsModalWidget